// extracted by mini-css-extract-plugin
export default {"noteContainer":"Style_noteContainer__al734"};